export const CLAIM_ON_WEB_CONTEXT: string = "/claimonweb";
const USER_CONTEXT: string = CLAIM_ON_WEB_CONTEXT + "/user";

export const CONTEXT_PATH_API: string = USER_CONTEXT + "/api";
